
import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf.js'
import pdfjsWorker from "pdfjs-dist/es5/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
import { uploadFileToGCS } from '@/utils/gcsUpload'
// export async function getPDFJS() {
//     const pdfjsLib = await import('pdfjs-dist/build/pdf')
//     const workerUrl = await import('pdfjs-dist/build/pdf.worker.entry')

//     pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl.default
//     return pdfjsLib
// }
// let pdfjsLib = ''
// getPDFJS().then((pdfjsLibs) => {
//     pdfjsLib = pdfjsLibs
// })

export const getPDFPages = (pdfUrl) => {
    return new Promise(async (resolve, reject) => {
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
        console.log(pdf._pdfInfo.numPages)
        resolve(pdf._pdfInfo.numPages)
    })
}


export const PDFload = (pdfUrl, uuid, fn) => {

    return new Promise(async (resolve, reject) => {

        let imgList = []
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;



        const savecanvas = document.createElement('canvas');
        const savecontext = savecanvas.getContext('2d');
        // const { output } = this.$refs;
        // 循环遍历每一页pdf，将其转成图片
        console.log(pdf._pdfInfo.numPages)
        for (let i = 1; i <= pdf._pdfInfo.numPages; i++) {
            // 获取pdf页
            const page = await pdf.getPage(i);
            // 获取正常页的尺寸

            var viewports = getOptimalViewport(page, 2048, true);
            //保存图片
            savecanvas.width = viewports.width
            savecanvas.height = viewports.height

            console.log('width:' + savecanvas.width)
            console.log('height:' + savecanvas.height)

            await page.render({ canvasContext: savecontext, viewport: viewports }).promise;

            // console.log(savecanvas.toDataURL('image/png'))
            savecanvas.toBlob((blob) => {
                const url = URL.createObjectURL(blob);
                let pdfName = `${uuid}/page/img/${uuid}_${i - 1}.jpeg`
                var fileName = `${uuid}_${i - 1}.jpeg`;
                var file = new File([blob], fileName, { type: 'image/jpeg' });
                console.log(file)
                uploadFileToGCS(file, pdfName).then((r) => {
                    console.log(r)
                    imgList.push(pdfName)
                    console.log(pdf._pdfInfo.numPages)
                    console.log(imgList.length)
                    fn(Math.floor((imgList.length / pdf._pdfInfo.numPages) * 100))
                    if (imgList.length == pdf._pdfInfo.numPages) {
                        resolve(imgList)
                    }
                }).catch(() => {
                    reject()
                })

            }, 'image/jpeg', 0.8);
        }
    })

}





export const newPDFload = (pdfUrl, uuid, fn) => {  //只分割，不上传

    return new Promise(async (resolve, reject) => {

        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;


        const savecanvas = document.createElement('canvas');
        const savecontext = savecanvas.getContext('2d');
        // const { output } = this.$refs;
        // 循环遍历每一页pdf，将其转成图片
        console.log(pdf._pdfInfo.numPages)
        for (let i = 1; i <= pdf._pdfInfo.numPages; i++) {
            // 获取pdf页
            const page = await pdf.getPage(i);
            // 获取正常页的尺寸

            var viewports = getOptimalViewport(page, 2048, true);

            savecanvas.width = viewports.width
            savecanvas.height = viewports.height

            console.log('width:' + savecanvas.width)
            console.log('height:' + savecanvas.height)

            await page.render({ canvasContext: savecontext, viewport: viewports }).promise;

            // console.log(savecanvas.toDataURL('image/png'))
            savecanvas.toBlob((blob) => {
                const url = URL.createObjectURL(blob);
                let pdfName = `${uuid}/page/img/${uuid}_${i - 1}.jpeg`
                var fileName = `${uuid}_${i - 1}.jpeg`;
                var file = new File([blob], fileName, { type: 'image/jpeg' });

                console.log(file)


                fn({
                    file,
                    url,
                    pdfName
                })

            }, 'image/jpeg', 0.8);
        }
    })

}


export const newPDFUpLoadList = (list, fn) => {
    return new Promise(async (resolve, reject) => {
        const uploadPromises = list.map((el, index) => {
            return uploadFileToGCS(el.file, el.pdfName)
                .then(() => {
                    fn(Math.floor(((index + 1) / list.length) * 100));
                    return el.pdfName;
                })
        });

        try {
            const imgList = await Promise.all(uploadPromises);
            resolve(imgList);
        } catch (error) {
            reject(error);
        }
    });
};



/**
 * 返回不会超过 maxSize 的 viewport。
 * - 始终以 page.getViewport({ scale: 1 }) 为基准（避免“二次放大”问题）
 * - allowUpscale = true 时会放大小图直至 maxSize（但不超过）
 * - allowUpscale = false 时只会缩小大图（不会放大）
 */
function getOptimalViewport(page, maxSize = 2048, allowUpscale = false) {
    // 强制取未缩放基准（避免外部传入已缩放 viewport 导致二次缩放）
    const baseViewport = page.getViewport({ scale: 1 });
    const originalWidth = baseViewport.width;
    const originalHeight = baseViewport.height;

    // 计算需放缩的比例（使宽和高都不超过 maxSize）
    const scaleX = maxSize / originalWidth;
    const scaleY = maxSize / originalHeight;
    let scale = Math.min(scaleX, scaleY);

    // 如果不允许放大，限制最大为 1（只缩小，不放大）
    if (!allowUpscale) {
        scale = Math.min(scale, 1);
    }

    // 限制极端值（可根据需要调整）
    const MIN_SCALE = 0.01;
    const MAX_SCALE = 16;
    scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale));

    // 生成最终 viewport
    let finalViewport = page.getViewport({ scale });

    // 双重保险：若由于浮点或 pdf.js 行为仍超出 maxSize，则再修正
    if (finalViewport.width > maxSize || finalViewport.height > maxSize) {
        const fixScale = Math.min(maxSize / finalViewport.width, maxSize / finalViewport.height);
        scale = scale * fixScale;
        finalViewport = page.getViewport({ scale });
    }

    console.log(
        `[getOptimalViewport] base: ${originalWidth}x${originalHeight}, ` +
        `scaleX: ${scaleX.toFixed(4)}, scaleY: ${scaleY.toFixed(4)}, ` +
        `allowUpscale: ${allowUpscale}, finalScale: ${scale.toFixed(4)}, ` +
        `final: ${finalViewport.width.toFixed(0)}x${finalViewport.height.toFixed(0)}`
    );

    return finalViewport;
}

